export default __webpack_public_path__ + "static/media/message.cc031113.svg";